import { gql } from '@apollo/client';

import { stimulusResourceFragment } from 'approot/shared/stimulus/stimulus.graphql';

export const studentLessonStimulusFragment = gql`
  fragment StudentLessonStimulusFragment on Lesson {
    id
    stimulusResources {
      ...StimulusResource
    }
  }
  ${stimulusResourceFragment}
`;
